<template>
<b-container>

    <p class="h5 mb-4" v-show="surveyAboutName != null" v-html="$t('html.surveyAbout', {name: surveyAboutName})"></p>

        <b-row>
          <b-col>
          <BaseRadioInput v-model="interviewedByProxy"
                                :v="$v.interviewedByProxy"
                                :label="$t('labels.interviewedByProxy')"
                                :options=yesNoUnknownOptions
                                slug="interviewedByProxy"/>

          </b-col>
          <b-col cols="12" lg="12">
            <BaseTextInput v-model="proxyName"
                  v-if="interviewedByProxy == 'Y'"
                              :v="$v.proxyName"
                              :label="$t('labels.proxyName')"
                              slug="proxyName"/>
          </b-col>
        </b-row>

    <div class="card mb-4">
  <div class="card-header">
   <h2 class="my-2">{{$t('sections.aboutYou', {name: surveyAboutName ? surveyAboutName : ''})}}</h2>
  </div>
  <div class="card-body">

    <b-row>
      <b-col cols="12" lg="6">
        <BaseTextInput v-model="firstName" 
                            :v="$v.firstName"
                            :label="$t('labels.fname')"
                            setId="personFirstName"
                            slug="firstName"/>
      </b-col>
      <b-col cols="12" lg="6">
        <BaseTextInput v-model="lastName" 
                            :v="$v.lastName"
                            :label="$t('labels.lname')"
                            setId="personLastName"
                            slug="lastName"/>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" lg="6">
        <BaseDateOfBirthTextInput v-model="dateOfBirth"
                            :v="$v.dateOfBirth"
                            :label="$t('labels.dob')"
                            slug="birthDate"
                            :messages="dobMessages"
                            mask="##/##/####"/>
      </b-col>
      <b-col cols="12" lg="6">
        <BaseRadioInput v-model="sex" 
                            :v="$v.sex"
                            :label="$t('labels.sex')"
                            :options=sexOptions
                            slug="sex"/>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" lg="12">
        <BaseTextInput v-model="emailAddress" 
                            :v="$v.emailAddress"
                            :label="$t('labels.email')"
                            :tip="$t('tips.email')"
                            setId="emailAddress"
                            slug="emailAddress"/>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" lg="6">
        <BaseMaskedTextInput v-model="phoneNbr" 
                            :v="$v.phoneNbr"
                            :label="$t('labels.phone')"
                            mask="(###)###-####"
                            slug="phoneNbr"/>
      </b-col>
      <b-col cols="12" lg="6">
        <BaseMaskedTextInput v-model="otherPhoneNbr" 
                            :v="$v.otherPhoneNbr"
                            :label="$t('labels.phoneOther')"
                            mask="(###)###-####"
                            slug="otherPhoneNbr"/>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <BaseSelector v-model="languageText" 
                      :v="$v.languageText"
                      :label="$t('labels.language')"
                      :options=languagePrefOptions
                      slug="prefLanguage"/>
      </b-col>
    </b-row>

    </div>
    </div>


<div class="card mb-4">
  <div class="card-header">
   <h2 class="my-2">{{$t('sections.livingLocation')}}</h2>
   <p class="text-muted" style="margin-top: -10px;">{{$t('sections.mailingaddress')}}</p>
  </div>
  <div class="card-body">

    <b-row>
      <b-col cols="12" lg="12">
        <BaseTextInput v-model="streetAddress" 
                            :v="$v.streetAddress"
                            :label="$t('labels.street')"
                            setId="streetAddress"
                            slug="streetAddress"/>
      </b-col>
    </b-row>
        <b-row>
      <b-col cols="12" lg="12">
        <BaseTextInput v-model="streetAddress2" 
                            :v="$v.streetAddress2"
                            :label="$t('labels.street2')"
                            setId="streetAddress2"
                            slug="streetAddress2"/>
      </b-col>
    </b-row>

    
    <b-row>
      <b-col cols="12" lg="3">
        <BaseTextInput v-model="city" 
                            :v="$v.city"
                            :label="$t('labels.city')"
                            setId="city"
                            slug="city"/>
      </b-col>
      <b-col cols="12" lg="3">
        <BaseSelector v-model="state" 
                            :v="$v.state"
                            :label="$t('labels.state')"
                            :options=stateOptions
                            slug="state"/>
      </b-col>
      <b-col cols="12" lg="3">
        <BaseMaskedTextInput v-model="zip" 
                            :v="$v.zip"
                            :label="$t('labels.zip')"
                            mask="#####-####"
                            slug="zip"/>
      </b-col>
      <b-col cols="12" lg="3" v-if="state === 'MN'">
        <BaseSelector v-model="county" 
                            :v="$v.county"
                            :label="$t('labels.county')"
                            :options=countyOptions
                            slug="county"/>
      </b-col>
    </b-row>

    <b-row v-if="promptForReservation">
     <b-col cols="12" lg="12">
        <BaseSelector v-model="livingReservation" 
                            :v="$v.livingReservation"
                            :label="$t('labels.livingReservation')"
                            :options=reservationOptions
                            slug="livingReservation"/>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" lg="12">
        <BaseRadioInput v-model="privateResidence"
                          :v="$v.privateResidence"
                          :label="$t('labels.privateResidence')"
                          :options=yesNoOptions
                          slug="privateResidence"/>
      </b-col>
    </b-row>

    <b-row v-if="privateResidence === 'N'">
      <b-col cols="12" lg="12">
        <BaseRadioInput v-model="livingSetting"
                          :v="$v.livingSetting"
                          :label="$t('labels.livingSetting')"
                          :options=livingOptions
                          slug="livingSetting"/>
      </b-col>
    </b-row>

  <b-row v-if="livingSetting === '8'">
    <b-col>
      <BaseTextInput v-model="otherLivingSetting" v-if="livingSetting === '8'"
          :v="$v.otherLivingSetting"
          :label="$t('labels.otherLivingSetting')"
          slug="otherLivingSetting"/>
    </b-col>
  </b-row>

    </div>
    </div>

    <div class="card mb-4">
      <div class="card-header">
        <h2 class="my-2">{{$t('sections.demographics')}}</h2>
      </div>
      <div class="card-body">
         <b-row>
            <b-col>
              <BaseMultiCheckboxInput v-model="raceSelection" :v="$v.race"
                      :label="$t('labels.race')"
                      :options=raceOptions
                      slug="race"/>  
            </b-col>
          </b-row>

          <b-row v-if="_.includes(raceSelection, 'O')">
            <b-col>
              <BaseTextInput v-model="otherRace" v-if="_.includes(raceSelection, 'O')"
                  :v="$v.otherRace"
                  :label="$t('labels.otherRace')"
                  slug="otherRace"/>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col>
              <BaseSelector v-model="tribe"
                  :v="$v.tribe"
                  :label="$t('labels.tribe')"
                  :options=tribeOptions
                  slug="tribe"/>
            </b-col>
          </b-row>

          <b-row v-if="tribe === '88'">
            <b-col>
              <BaseTextInput v-model="otherTribe" v-if="tribe === '88'"
                  :v="$v.otherTribe"
                  :label="$t('labels.otherTribe')"
                  slug="otherTribe"/>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <BaseRadioInput v-model="hispanic" 
                                  :v="$v.hispanic"
                                  :label="$t('labels.hispanic')"
                                  :options=yesNoOptions
                                  slug="hispanic"/>
            </b-col>
          </b-row>
      </div>
    </div>

    <div v-show="false">
    <b-row>
      <b-col cols="12" lg="12">
        <h2>{{$t('sections.contacttracing')}}</h2>
        <p v-html="$t('html.contacttracing')"></p>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" lg="12">
        <BaseRadioInput v-model="currentlyEmployed"
                          :v="$v.currentlyEmployed"
                          :label="$t('labels.employed')"
                          :options=yesNoOptions
                          slug="currentlyEmployed"/>
      </b-col>
      <b-col cols="12" lg="12">
        <BaseTextInput v-model="currentEmployer" v-if="currentlyEmployed === 'Y'"
                          :v="$v.currentEmployer"
                          :label="$t('labels.currentEmployer')"                          
                          slug="currentEmployer"/>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" lg="12">
        <BaseRadioInput v-model="currentlySchooled"
                          :v="$v.currentlySchooled"
                          :label="$t('labels.school')"
                          :options=yesNoOptions
                          slug="currentlySchooled"/>
      </b-col>
      <b-col cols="12" lg="12">
        <BaseTextInput v-model="currentSchool" v-if="currentlySchooled === 'Y'"
                          :v="$v.currentSchool"
                          :label="$t('labels.currentSchool')"                          
                          slug="currentSchool"/>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" lg="12">
        <BaseRadioInput v-model="currentlyCollege"
                          :v="$v.currentlyCollege"
                          :label="$t('labels.college')"
                          :options=yesNoOptions
                          slug="currentlyCollege"/>
      </b-col>
      <b-col cols="12" lg="12">
        <BaseTextInput v-model="currentCollege" v-if="currentlyCollege === 'Y'"
                          :v="$v.currentCollege"
                          :label="$t('labels.currentCollege')"                          
                          slug="currentCollege"/>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" lg="12">
        <BaseRadioInput v-model="nonhouseholdContact"
                          :v="$v.nonhouseholdContact"
                          :label="$t('labels.nonhouseholdContact')"
                          :options=yesNoUnknownOptions
                          :tip="$t('tips.nonhouseholdContact')"
                          slug="nonhouseholdContact"/>
      </b-col>
    </b-row>
    </div>


<div class="card mb-4">
  <div class="card-header">
    <h2 class="my-2">{{$t('sections.healthhistory')}}</h2>
  </div>
  <div class="card-body">
   

    <b-row>
      <b-col>
      <BaseRadioInput v-model="underlyingConditions" 
                            :v="$v.underlyingConditions"
                            :label="$t('labels.underlyingConditions')"
                            :tip="$t('tips.underlyingConditions')"
                            :options=yesNoUnknownOptions
                            slug="underlyingConditions"/>

      </b-col>
      <b-col cols="12" lg="12">
        <BaseTextInput v-model="prexistingConditions" 
              v-if="underlyingConditions === 'XXX' || underlyingConditions === 'XXX'"
                          :v="$v.prexistingConditions"
                          :label="$t('labels.prexistingConditions')"                          
                          slug="prexistingConditions"/>
      </b-col>
    </b-row>

    <b-row v-show="sex != 'M'">
      <b-col>
        <BaseRadioInput v-model="pregnant" 
                            :v="$v.pregnant"
                            :label="$t('labels.pregnant')"
                            :options=yesNoUnknownNaOptions
                            slug="pregnant"/>
      </b-col>
    </b-row>
    <b-row v-if="pregnant === 'Y'">
      <b-col>
        <BaseTextInput v-model="obgynProvider"
                       :v="$v.obgynProvider"
                       :label="$t('labels.obgynProvider')"
                       slug="obgynProvider"/>
      </b-col>
    </b-row>
    <b-row v-if="pregnant === 'Y'">
      <b-col cols="12" lg="8">
        <BaseFacilitySelector v-model="obgynClinicNameObj"
          :v="$v.obgynClinicNameObj"
          :label="$t('labels.obgynClinicName')"
          slug="obgynClinicName"
          :tip="$t('tips.otherSelection')"/>
      </b-col>
      <b-col cols="12" lg="4">
        <BaseMaskedTextInput v-model="obgynClinicPhone"
                       :v="$v.obgynClinicPhone"
                       :label="$t('labels.obgynClinicPhone')"
                       mask="(###)###-####"
                       slug="obgynClinicPhone"/>
      </b-col>
    </b-row>
    <b-row v-if="obgynClinicNameObj.value === 'OTHER'">
      <b-col cols="12" lg="8">
        <BaseTextInput v-model="obgynClinicNameOther"
          :v="$v.obgynClinicNameOther"
          :label="$t('labels.pleaseSpecify')"
          slug="obgynClinicNameOther"/>
      </b-col>
    </b-row>

    <b-row v-if="pregnant === 'Y'">
      <b-col>
        <BaseTextInput v-model="pregnancyGestationWeeks"
                       :v="$v.pregnancyGestationWeeks"
                       :label="$t('labels.pregnancyGestationWeeks')"
                       slug="pregnancyGestationWeeks"/>
      </b-col>
    </b-row>
    <b-row v-if="pregnant === 'Y'">
      <b-col>
        <BaseHospitalSelector v-model="obgynHospitalObj"
            :v="$v.obgynHospitalObj"
            :label="$t('labels.obgynHospital')"
            slug="obgynHospital1"
            :tip="$t('tips.otherSelection')"/>
      </b-col>
    </b-row>
    <b-row v-if="obgynHospitalObj.value === 'OTHER'">
      <b-col cols="12" lg="8">
        <BaseTextInput v-model="obgynHospitalOther"
          :v="$v.obgynHospitalOther"
          :label="$t('labels.pleaseSpecify')"
          slug="obgynHospitalOther"/>
      </b-col>
    </b-row>
    <b-row v-if="pregnant === 'Y'">
      <b-col>
        <BaseRadioInput v-model="obgynPermission"
                        :v="$v.obgynPermission"
                        :label="$t('labels.obgynPermission')"
                        :options="yesNoOptions"
                        slug="obgynPermission"/>
      </b-col>
    </b-row>
    </div>
    </div>


<div class="card mb-4">
  <div class="card-header">
    <h2 class="my-2">{{$t('sections.symptoms')}}</h2>
  </div>
  <div class="card-body">
    

    <b-row>
      <b-col cols="12" lg="12">
        <p>{{$t('tips.covidSymptoms')}}</p>
        <ul>
          <li v-for="symptom in covid19Symptoms" :key="symptom" 
            style="list-style: disc; margin-left: 35px; margin-bottom: 0px">
            {{symptom}}
          </li>
        </ul>
        </b-col>
    </b-row>
    <b-row>
      <b-col>
        <BaseRadioInput v-model="covidSymptoms" 
                            :v="$v.covidSymptoms"
                            :label="$t('labels.covidSymptoms')"
                            :options=symptomYesNoOptions
                            slug="covidSymptoms"/>
      </b-col>
    </b-row>
    <b-row v-if="covidSymptoms === 'Y'">
      <b-col>
      <BaseDateInput v-model="covidSymptomsStart" 
                            :v="$v.covidSymptomsStart"
                            :label="$t('labels.covidSymptomsStart')"
                            :tip="$t('tips.covidSymptomsStart')"
                            :messages="covidSymptomsStartMessages"
                            slug="covidSymptomsStart"/>

      </b-col>
    </b-row>
    <b-row v-if="covidSymptoms === 'Y'">
      <b-col>
      <BaseDateInput v-model="recoveryDate"
                            :v="$v.recoveryDate"
                            :label="$t('labels.recoveryDate')"
                            :tip="$t('tips.recoveryDate')"
                            :messages="recoveryDateMessages"
                            slug="recoveryDate"/>
      </b-col>
    </b-row>
    <b-row v-if="covidSymptoms === 'N'">
      <b-col>
        <BaseDateInput v-model="covidLastTested"
                       :v="$v.covidLastTested"
                       :label="$t('labels.covidLastTested')"
                       :messages="covidLastTestedMessages"
                       :tip="''"
                       slug="covidSymptomsStart"/>

      </b-col>
    </b-row>
    </div>
    </div>

<div class="card mb-4">
  <div class="card-header">
    <h2 class="my-2">{{$t('sections.vaccinationHistory')}}</h2>
  </div>
  <div class="card-body">

  <b-row>
    <b-col>
      <BaseRadioInput v-model="srHadVax"
                          :v="$v.srHadVax"
                          :label="$t('labels.srHadVax')"
                          :options=yesNoUnknownOptions
                          slug="srHadVax"/>
    </b-col>
  </b-row>
  <b-row v-if="srHadVax === 'Y'">
    <b-col>
      <BaseDateInput v-model="srVaxDate1" 
                            :v="$v.srVaxDate1"
                            :label="$t('labels.srVaxDate1')"
                            :messages="srVaxDateMessages"
                            slug="srVaxDate1"/>   
      </b-col>
  </b-row>
  <b-row v-if="srHadVax === 'Y'">
    <b-col>
      <BaseDateInput v-model="srVaxDate2" 
                            :v="$v.srVaxDate2"
                            :label="$t('labels.srVaxDate2')"
                            :messages="srVaxDateMessages"
                            slug="srVaxDate2"/>
      </b-col>
  </b-row>
  <b-row v-if="srHadVax === 'Y'">
    <b-col>
      <BaseDateInput v-model="srVaxDate3" 
                            :v="$v.srVaxDate3"
                            :label="$t('labels.srVaxDate3')"
                            :messages="srVaxDateMessages"
                            slug="srVaxDate3"/>
    
      </b-col>
  </b-row>
  
  </div>
  </div>


  
</b-container>

</template>

<script>
import { required, email, minLength, maxLength, numeric, requiredUnless, requiredIf, minValue, maxValue } from 'vuelidate/lib/validators'
import { commonOptions } from '@/mixins/commonOptions.js'
import moment from 'moment'
import _ from "lodash"
import minDate from '@/validators/minDate'
import maxDate from '@/validators/maxDate'
import minDateOfBirth from '@/validators/minDateOfBirth'
import maxDateOfBirth from '@/validators/maxDateOfBirth'
import isValidDateOfBirth from '@/validators/isValidDateOfBirth'

export default {
    mixins: [
       commonOptions
    ],

  props: {
    surveyAboutName: String
  },

  data: () => ({
    interviewedByProxy: '',
    proxyName: '',
    firstName: '',
    lastName: '',
    dateOfBirth: null, 
    sex: '',
    otherSex: '',
    lgbtCode: '',
    emailAddress: '',
    phoneNbr: '',
    otherPhoneNbr: '',
    streetAddress: '',
    streetAddress2: '',
    city: '',
    state: 'MN',
    zip: '',
    county: '',
    languageText: '',
    privateResidence: '',
    livingSetting: '',
    dpsAddress: '',
    currentlyEmployed: '',
    currentEmployer: '',
    currentlySchooled: '',
    currentSchool: '',
    currentlyCollege: '',
    currentCollege: '',
    nonhouseholdContact: '',

    raceSelection: [],
    race: '',
    otherRace: '',
    tribe: '',
    otherTribe: '',
    otherLivingSetting: '',
    hispanic: null,

    underlyingConditions: '',
    prexistingConditions: '',

    pregnant: '',
    obgynProvider:'',
    obgynClinicName:'',
    obgynClinicPhone:'',
    pregnancyGestationWeeks:'',
    obgynHospital:'',
    obgynHospitalObj: {},
    obgynHospitalOther: '',
    obgynClinicNameObj: {},
    obgynClinicNameOther: '',
    obgynPermission:'',

    covidSymptoms: '',
    covidSymptomsStart: '',
    covidLastTested: '',

    recoveryDate: '',
    srHadVax: '',
    srVaxDate1: '',
    srVaxDate2: '',
    srVaxDate3: '',

    dobMessages: {
      minDateOfBirth: 'Birth Date must be after 01/01/1900.',
      maxDateOfBirth: 'Birth Date must not be in the future.'
    },
    covidSymptomsStartMessages: {
      minDate: 'Please only report COVID symptoms occurring within the past 30 days.',
      maxDate: 'Symptom Start Date must not be in the future.'
    },

    covidLastTestedMessages: {
      minDate: 'Please only report COVID Tests taken within the past 30 days.',
      maxDate: 'Last Tested Date must not be in the future.'
    },
    recoveryDateMessages: {
      minDate: 'Recovery Date must not be before Symptom Start Date',
      maxDate: 'Recovery Date must not be in the future.'
    },
    srVaxDateMessages: {
      minDate: 'Vaccination Date must be after 01/01/1900.',
      maxDate: 'Vaccination Date must not be in the future.'
    },
    livingReservation: '',

  }),
computed: {
  _: function() {
      return _
  },

  reservationOptions: function() {
    var filtered = this.tribeOptions.filter(
      function(value, index, arr) { return value.value != '22' && value.value != '88' && value.value != '77'}
    )
    filtered.unshift(
      { value:"", text:"No" }
    )
    return filtered
  },

  promptForReservation: function() {
    var counties = [
            "Becker County", 
            "Beltrami County",
            "Carlton County",
            "Cass County",
            "Chippewa County",
            "Clearwater County",
            "Cook County",
            "Crow Wing County",
            "Goodhue County",
            "Hubbard County",
            "Itasca County",
            "Koochiching County",
            "Mahnomen County",
            "Marshall County",
            "Mille Lacs County",
            "Morrison County",
            "Norman County",
            "Pennington County",
            "Polk County",
            "Redwood County",
            "Renville County",
            "Scott County",
            "St Louis County",
            "Yellow Medicine County"
    ]

    if (!this.county) {
      return true
    }
    return _.includes(counties, this.county)
  }
},
  validations() {
    return {
      firstName: { required, maxLength: maxLength(75) },
      lastName: { required, maxLength: maxLength(75) },
      dateOfBirth: { required, 
          minDateOfBirth: minDateOfBirth(new Date("1900-01-01")),
          maxDateOfBirth: maxDateOfBirth(new Date()),
          isValidDateOfBirth: isValidDateOfBirth()
      },
      sex: { required: false },
      otherSex: { required: false },
      lgbtCode: { required: false },
      emailAddress: { required, email, maxLength: maxLength(100) },
      languageText: { required: false },
      phoneNbr: { required, maxLength: maxLength(15),
        isValid(tel) {
          var phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
          return phoneRegex.test(tel)
        } 
      },
      otherPhoneNbr: { required: false, maxLength: maxLength(15),
        isValid(tel) {
          if (tel) {
            var phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
            return phoneRegex.test(tel)
          } else {
            return true
          }
        } 
      },
      streetAddress: { required: false, maxLength: maxLength(100) },
      streetAddress2: { required: false, maxLength: maxLength(100) },
      city: { required, maxLength: maxLength(75) },
      state: { required: false, maxLength: maxLength(2) },
      zip: { required: false, maxLength: maxLength(10) },
      county: { required: requiredIf(function() { return this.state === 'MN' }), 
        maxLength: maxLength(30) },
      privateResidence: { required: false },
      livingSetting: { required: false, maxLength: maxLength(3) },
      dpsAddress: { required: false, maxLength: maxLength(100) },
      currentlyEmployed: { required: false, maxLength: maxLength(3) },
      currentEmployer: { required: false, maxLength: maxLength(100) },
      currentlySchooled: { required: false, maxLength: maxLength(3) },
      currentSchool: { required: false, maxLength: maxLength(100) },
      currentlyCollege: { required: false, maxLength: maxLength(3) },
      currentCollege: { required: false, maxLength: maxLength(100) },
      nonhouseholdContact: { required: false, maxLength: maxLength(3) },
      underlyingConditions: { required: false, maxLength: maxLength(3) },
      prexistingConditions: { required: false, maxLength: maxLength(100) },
      pregnant: { required: false, maxLength: maxLength(3) },
      obgynProvider:{ required: false, maxLength: maxLength(100) },
      obgynClinicName:{ required: false, maxLength: maxLength(100) },      
      obgynClinicPhone: {
        required: false, maxLength: maxLength(15),
        isValid(tel) {
          var phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
          return phoneRegex.test(tel) || tel === ''
        }
      },
      pregnancyGestationWeeks:{ required: false, numeric, maxLength: maxLength(2) },
      obgynHospital:{ required: false, maxLength: maxLength(100) },
      obgynHospitalOther:{ required: false, maxLength: maxLength(100) },
      obgynHospitalObj: { required: false },
      obgynClinicNameObj: { required: false },
      obgynClinicNameOther: { required: false, maxLength: maxLength(100)},
      obgynPermission:{ required: false, maxLength: maxLength(3) },

      race: { required: false },
      hispanic: { required: false },
      otherRace: { required: false,
                   maxLength: maxLength(20) },
      tribe: { required: false,
                   maxLength: maxLength(10) },
      otherTribe: { required: false, maxLength: maxLength(50)},
      covidSymptoms: { required, maxLength: maxLength(3) },
      covidSymptomsStart: { required: requiredIf(function() { return this.covidSymptoms === 'Y' }),
          minDate: minDate(moment().subtract(30, 'd')),
          maxDate: maxDate(new Date()) },
      recoveryDate: { required: false,
          minDate: minDate(this.covidSymptomsStart),
          maxDate: maxDate(new Date()) },
      srVaxDate1: { required: false },
      srVaxDate2: { required: false },
      srVaxDate3: { required: false },
      srHadVax: { required: false, maxLength: maxLength(3) },
      covidLastTested: { required: requiredIf(function() { return this.covidSymptoms === 'N'}),
        maxDate: maxDate(new Date()) },
      livingReservation: { required: false },
      otherLivingSetting: { required: false, maxLength: maxLength(50)},
      interviewedByProxy: { required: false, maxLength: maxLength(3) },
      proxyName: { required: false, maxLength: maxLength(150) },

      form: [ 'firstName', 'lastName', 'dateOfBirth', 'sex', 'otherSex', 'otherRace',
        'emailAddress', 'phoneNbr', 'otherPhoneNbr', 'streetAddress', 'streetAddress2','city', 'state', 'zip', 'county',
        'livingSetting', 'dpsAddress', 'currentlyEmployed', 'currentEmployer',
        'currentlySchooled', 'currentSchool', 'currentlyCollege', 'currentCollege',
        'nonhouseholdContact', 'tribe', 'otherTribe', 'otherLivingSetting' ,
        'underlyingConditions', 'prexistingConditions',
        'pregnant', 'obgynProvider', 'obgynClinicName', 'obgynClinicNameOther','obgynClinicPhone','pregnancyGestationWeeks','obgynHospital', 'obgynHospitalOther',
        'obgynPermission', 'covidSymptoms', 'covidSymptomsStart', 'covidLastTested', 'livingReservation', 'interviewedByProxy', 'proxyName',
        'recoveryDate', 'srVaxDate1', 'srVaxDate2', 'srVaxDate3', 'srHadVax' ]
    }
  },
  watch: {
    privateResidence() {
      if (this.privateResidence === 'Y') {
        this.livingSetting = '1'
      }
    },
     raceSelection: function () {
      if (!_.includes(this.raceSelection, 'O')) {
        this.otherRace = ''
        this.$nextTick(() => { this.$v.$reset() })
      }
      this.race = this.raceSelection.join()
    },

    state: function() {
      if (this.state != 'MN') {
        this.county = ''
      }
    },

    obgynHospitalObj: function() {
      if (this.obgynHospitalObj && this.obgynHospitalObj.value) {
        this.obgynHospital =  this.obgynHospitalObj.value
      } else {
        this.obgynHospital = ''
      }
    },

    obgynClinicNameObj: function() {
      if (this.obgynClinicNameObj && this.obgynClinicNameObj.value) {
        this.obgynClinicName =  this.obgynClinicNameObj.value
      } else {
        this.obgynClinicName = ''
      }
    }
  },
  methods: {
    focusFirstStatus() {
      var errorElements = document.querySelectorAll(".is-invalid");
      if (errorElements && errorElements.length > 0) {                        
        var elmnt = document.getElementById(errorElements[0].id);
        elmnt.scrollIntoView();
      }
    },

    validate() {
      this.$v.form.$touch()
      this.$nextTick(() => this.focusFirstStatus())
      
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid)
      return isValid
    }
  }
}
</script>

<style>

</style>
